<template>
  <div id="siteContent">
    <v-container fluid >
      <v-card id="siteList">
        <v-card-title primary-title>
          Site List
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="sites"
            :sort-by="['name']"
            :items-per-page="5"
            class="elevation-1"
            :loading="loading"
            hide-default-footer
            :disable-pagination="true"
          >
            <template v-slot:item.action="{ item }">
              <v-btn 
                @click ="editItem(item)"
                rounded
                 small color="primary">
                Edit Properties
              </v-btn>
              <v-btn 
                @click="selectItem(item)"
                rounded
                 small color="success">
                Select
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn 
            @click="refreshScripts" 
            rounded color="primary" 
            style="margin: 10px"
            :loading="generateButtonLoading"
            :disabled="generateButtonLoading"
          >
            Refresh All Scripts
          </v-btn>
          <v-btn @click="newItem" rounded color="secondary" style="margin: 10px">New</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    components: {
    },
    props: [ 'siteId'],
    data(){
      return {
        headers: [
          //{text: 'Id', align: 'left', value : 'id'},
          {text: 'Name', align: 'left', value: 'name'},
          {text: 'Action', align: 'right', value: 'action'}
        ],
        sites: [],
        loading: false,
        search: "",
        generateButtonLoading: false
      }
    },
    created(){
      this.getDataFromApi()
    },
    methods: {
      async getDataFromApi() {
        this.loading = true
        const request = {
          type : "management/site",
          action : "index",
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.sites = response.data
          this.loading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      async refreshScripts(){
        this.generateButtonLoading = true
        const request = {
          type : "management/site",
          action : "refreshScripts"
        }
        try {
          const accessToken = await this.$auth.getAccessToken()
          await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.generateButtonLoading = false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.generateButtonLoading = false  
        }
      },
      editItem(item){
        this.$router.push('/management/'+item.id+'/details')
      },
      selectItem(item){
        this.$router.push('/management/'+item.id+'/pages')
      },
      newItem(){
        this.$router.push('/management/site/new')
      }
    }
  }
</script>